import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const PodcastEmbed = ({ podcast, width = '100%', height = 180 }) => {
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        const script = document.createElement('script');
        script.src =
            'https://assets.transistor.fm/assets/embed-9952928d653ae77356ecb4ff51acf1f7d48a7df09a0b638a08bf105c497c5982.js';
        script.defer = true;
        containerRef.current?.appendChild(script);
        return () => {
            if (containerRef.current && containerRef.current.contains(script)) {
                containerRef.current.removeChild(script);
            }
        };
    }, []);
    const url = podcast.content.externalPodcastAsset;
    if (!url)
        return null;
    return (_jsx("div", { ref: containerRef, dangerouslySetInnerHTML: {
            __html: `<iframe src="${url}" width="${width}" height="${height}" frameborder="no" scrolling="no"></iframe>`,
        } }));
};
export default PodcastEmbed;
